/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use Auth0Prompt from application-types instead.
 */
export enum Auth0Prompt {
  // https://auth0.com/docs/customize/universal-login-pages/customize-login-text-prompts#prompt-values
  none = 'none', // To initiate a silent authentication request,
  login = 'login', // User session exists or not, it will redirect to login/signup page base on screen hint
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use Auth0ScreenHint from application-types instead.
 */
export enum Auth0ScreenHint {
  // https://auth0.com/docs/authenticate/login/auth0-universal-login/new-experience
  login = 'login',
  signup = 'signup',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use Auth0Parameter from application-types instead.
 */
export type Auth0Parameter = {
  prompt?: Auth0Prompt;
  screen_hint: Auth0ScreenHint;
  login_hint?: string;
  organization?: string;
  'ext-page-title'?: string;
  'ext-primary-color'?: string;
  'ext-primary-button-color'?: string;
  'ext-background-image'?: string;
  'ext-background-logo'?: string;
  invitation?: string;
  aiid?: string;
  connection?: string;
  ui_locales?: string;
};
